import React, { useState } from "react";

import { PlusOutlined } from "@ant-design/icons";
import "./DataFieldsAdd.css";

export default function DataFieldsAdd(props) {
  const {
    showDeleteModal,
    showEditModal,
    apiAddDataField,
  } = props;

  const [inputVal, setInputVal] = useState("");
  const handleHitEnter = async (e) => {
    if (e.key === "Enter") {
      const addSuccess = await apiAddDataField(inputVal.trim());
      if (addSuccess) {
        setInputVal("");
      }
    }
  };

  const handleAddOnClick = async () => {
    const addSuccess = await apiAddDataField(inputVal.trim());
    if (addSuccess) {
      setInputVal("");
    }
  };

  return (
    <div className={`dataFieldsAdd_formSection ${(showDeleteModal || showEditModal) ? "Disabled" : ""}`}>
      <div className="dataFieldsAdd_newFieldForm">
        <div className="dataFields_formLabel">Create New Field</div>
        <div className="dataFieldsAdd_formRow">
          <input
            className="dataFieldsAdd_formInput"
            onKeyUp={(e) => handleHitEnter(e)}
            type="text"
            placeholder="Enter Text"
            name="datafield"
            value={inputVal}
            onChange={(e) => setInputVal(e.target.value)}
          />
          <button
            type="button"
            className={inputVal.trim() ? "dataFieldsAdd_addButton" : "dataFieldsAdd_addButtonDisabled"}
            onClick={() => handleAddOnClick()}
            aria-label="Add field"
          >
            <PlusOutlined className="dataFieldsAdd_addButtonIcon" aria-hidden />
          </button>
        </div>
      </div>
    </div>
  );
}
